import React from 'react';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

import { useAppConfigContext } from '../../hooks/useAppConfigContext';
import { DEFAULT_CONFIG } from '../../utils/constants';

import styles from './Logo.module.css';

export const Logo = ({
  resetCards,
  className,
  size,
}: {
  resetCards?: () => void;
  className?: string;
  size?: 'sm' | 'xl';
}) => {
  const navigate = useNavigate();
  const config = useAppConfigContext() || DEFAULT_CONFIG;

  const classSize = size === 'xl' ? styles.textLarge : styles.textSmall;

  const handleClick = () => {
    if (resetCards) {
      resetCards();
    }
    navigate('/');
  };

  return (
    <button
      className={clsx(styles.logo, className)}
      onClick={handleClick}
      type="button"
    >
      <p className={classSize}>
        <span className="tracking-wider">{config.logo}</span>
      </p>
    </button>
  );
};
